module.exports = __webpack_public_path__ + "img/cabo.71ea1e93.png";